import { reportPromoUrlConfig } from 'entities/reportPromo';
import { reportPromoApi } from './reportPromoApi';

const getReportPromoListApi = reportPromoApi.injectEndpoints({
  endpoints: (builder) => ({
    getReportPromoList: builder.query({
      query: (params) => ({
        url: `/promo-b2b/admin/promo-b2b/admin/activities/participants/?wallet_app_type=b2b&${reportPromoUrlConfig(
          params,
        )}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetReportPromoListQuery } = getReportPromoListApi;
